import { createAction } from 'redux-actions';

export const getSentimentDataRequest = createAction('GET_SENTIMENT_DATA_REQUEST');
export const getSentimentDataSuccess = createAction('GET_SENTIMENT_DATA_SUCCESS');
export const getSentimentDataFail = createAction('GET_SENTIMENT_DATA_FAIL');
